var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-row"},[_c('typography',{staticClass:"price-row__label",attrs:{"light":"","no-margin":""}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('typography',{staticClass:"price-row__quantity",attrs:{"light":"","no-margin":""}},[_vm._v(" "+_vm._s(_vm.quantity)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }